import { render, staticRenderFns } from "./editarDocumentos.vue?vue&type=template&id=20ce41b5"
import script from "./editarDocumentos.vue?vue&type=script&lang=js"
export * from "./editarDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports